export default "__VITE_ASSET__DldJ9neL__"